/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type CbOrgStatusEnum = 'PROVISIONED' | 'PURGING' | 'PURGED';

export const CbOrgStatusEnum = {

    PROVISIONED: 'PROVISIONED' as CbOrgStatusEnum,

    PURGING: 'PURGING' as CbOrgStatusEnum,

    PURGED: 'PURGED' as CbOrgStatusEnum
};

